export enum ModoAssinaturaDigital {
    SEQUENCIAL = 'SEQUENCIAL',
    PARALELO_POR_DOCUMENTO = 'PARALELO_POR_DOCUMENTO',
}